// extracted by mini-css-extract-plugin
module.exports = {"imgFile":"index__imgFile__wv509","textFile":"index__textFile__2cN1v","fullpage":"index__fullpage__3ClN2"};